import React from 'react';
import PropTypes from 'prop-types';
import ClientContract from './ClientContract';
import VendorContract from './VendorContract';

function ContractMessage({ contractType }) {
	switch (contractType) {
		case 'vendor':
			return <VendorContract />;
		case 'client':
			console.log('came inside client');
			return <ClientContract />;
		default:
			return null;
	}
}

ContractMessage.propTypes = {
	contractType: PropTypes.string,
};

export default ContractMessage;
